import React from 'react';
import { MoviesContent, METART_INTIMATE, MoviesContentProps } from './MoviesContent';

export const MetartIntimateMovies = (props: MoviesContentProps) => {
  return (
    <MoviesContent
      {...props}
      pageType={METART_INTIMATE}
      pageTypeParams={{ intimateSelectionOnly: true }}
      basePageUrl="/erotic-films/intimate"
    />
  );
};
